var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIconNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9792 0.903322C14.5576 0.546578 13.9267 0.599159 13.5699 1.02077C13.1878 1.47147 12.8011 1.91835 12.4129 2.36374C11.7082 3.17203 10.7565 4.24775 9.76515 5.32176C8.7706 6.3992 7.74946 7.46027 6.90284 8.24641C6.77392 8.36612 5.80985 9.40309 5.59079 9.2836C5.4729 9.2193 5.31799 9.11032 5.12992 8.94912C4.75395 8.62686 4.33667 8.17537 3.93485 7.69319C3.42502 7.0814 2.94343 6.44163 2.4996 5.78005C2.1963 5.3266 1.56692 5.198 1.11192 5.50132C0.652396 5.80768 0.528378 6.42878 0.83473 6.88831C1.31764 7.61081 1.84213 8.30603 2.3984 8.97356C2.82992 9.49137 3.3293 10.0399 3.82833 10.4676C4.3405 10.9066 4.96516 11.3334 5.66663 11.3334C6.66084 11.3334 7.59116 10.3365 8.26374 9.712C9.16712 8.87315 10.2293 7.76755 11.2348 6.67832C12.2434 5.58566 13.2084 4.49472 13.9204 3.67801C14.3151 3.22521 14.7082 2.77087 15.0967 2.31265C15.4534 1.89104 15.4008 1.26007 14.9792 0.903322Z",
    fill: "#0E1337"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIconNeutral);
export default __webpack_public_path__ + "static/media/correct-icon-neutral.4bdd8a3c60c7fd5d042c27e33259476e.svg";
export { ForwardRef as ReactComponent };